<template>
  <div class="d-flex align-items-center mt-3">
    <div class="d-flex align-items-center flex-shrink-0 border-right border-light-dark pr-3">
      <div class="input-file-button">
        <input type="file" @change="onFileChange" />
        <button class="btn btn-sm btn-blue-ml" style="border-radius: 30px; border-top-left-radius: 0;">Anexar Laudo Médico</button>
      </div>
    </div>

    <div class="row flex-grow-1 pl-3">
      <div class="mx-3 my-1 d-flex bg-light-dark border-0 shadow-sm pl-2" style="border-radius: 30px; border-top-left-radius: 0;" v-for="(item, index) in files" :key="index">
        <div class="medical-report d-flex align-items-center pr-2" @click="openLaudo(item.file)">{{ item.name }}</div>
        <button type="button" class="btn btn-sm btn-light-dark" @click="remove(item.id, index)">
          <delete-icon class="align-text-bottom text-blue-ml" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DeleteIcon from "vue-material-design-icons/Delete.vue";

export default {
  name: "MedicalReport",

  data() {
    return {
      isSaving: false,
      files: [],
    };
  },

  components: {
    DeleteIcon,
  },

  mounted() {
    this.initMedicalReport();
  },

  methods: {
    initMedicalReport() {
      this.$store
        .dispatch(
          "graphql_queries/query",
          `
        user( id: "${this.$store.state.user.profile.id}" ){
            medicalReports {
                id
                name
                file
          }
        }
      `
        )
        .then((data) => {
          let medicalReport = data.user.medicalReports;
          medicalReport.forEach((element) => {
            this.files.push(element);
          });
        });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.$emit('isLoading', true);
      this.createFile(files[0]);
    },

    createFile(file) {
      var reader = new FileReader();
      var vm = this;

      var fileName = file.name.replace(/[^a-z0-9]/gi, "");
      var fileFormat = fileName.substr(-3);

      var formatos = ["pdf"];
      var maxSize = 2100000;
      if (formatos.indexOf(fileFormat) === -1) {
        this.$swal(
          "Falha no carregamento do arquivo",
          "Seu arquivo deve estar no formato .pdf",
          "error"
        );

        this.isLoading = false;
        this.$emit('isLoading', false);
        return false;
      }
      if (file.size > maxSize) {
        this.$swal(
          "Falha no carregamento do arquivo",
          "Seu arquivo não pode ter mais que 2MB",
          "error"
        );

        this.isLoading = false;
        this.$emit('isLoading', false);
        return false;
      }

      reader.readAsDataURL(file);
      reader.onload = (e) => {
        setTimeout(() => {
          this.saveFile(e.target.result, fileName.replace("pdf", ""));
        }, 100);
      };
    },

    saveFile(file, fileName) {
      this.$store
        .dispatch("user/uploadMedicalReport", {
          document_base64: file,
          original_filename: fileName,
        })
        .then((response) => {
          let laudo = response.data.uploadUserDocument;
          this.files.push(laudo);
          this.$emit('isLoading', false);
        }).catch(()=>{
          this.$emit('isLoading', false);
        })
    },

    openLaudo(link) {
      this.$EventBus.$emit('showModalIframe', link);
    },

    remove(file_id, index) {
      this.$swal({
        title: "Atenção",
        text: "Tem certeza que deseja remover o laudo?",
        type: "error",
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim, desejo remover",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("user/removeMedicalReports", { id: file_id })
            .then((response) => {
              this.files.splice(index, 1);
            })
            .catch((error) => {
              this.$swal(
                "Erro ao excluir arquivo.",
                "Por favor, tente novamente mais tarde.",
                "error"
              );
              return false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-file-button {
  position: relative;
  overflow: hidden;

  input {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
  }
}
.medical-report{
  cursor: pointer;
}
</style>